/**
 * Module dependencies.
 */

import { ErrorField } from '../../error-field/error-field';
import { FormField } from '../../form-field/form-field';
import { Input } from 'app/components/ui/input';
import React, { forwardRef } from 'react';
import moment from 'moment';

/**
 * `DatePickerProps` type.
 */

export type DatePickerProps = Omit<React.ComponentProps<'input'>, 'value' | 'onChange'> & {
  error: any;
  className?: string;
  invalid?: boolean;
  isDirty?: boolean;
  isTouched?: boolean;
  label: string;
  onChange?: (value: moment.Moment | null) => void;
  value?: moment.Moment | string | null;
};

/**
 * Export `DatePickerComponent` component.
 */

export function DatePickerComponent(props: DatePickerProps, forwardedRef: any): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { className, error, invalid, isDirty, isTouched, label, onChange, value, ...rest } = props;

  return (
    <FormField className={className} label={label}>
      <Input
        {...rest}
        onChange={event => {
          const nextValue = event.target.value;

          onChange?.(nextValue ? moment(nextValue, 'YYYY-MM-DD') : null);
        }}
        ref={forwardedRef}
        type={'date'}
        value={value ? moment(value).format('YYYY-MM-DD') : ''}
      />

      <ErrorField error={error} isVisible={invalid || isTouched} />
    </FormField>
  );
}

/**
 * Export `DatePicker` component.
 */

export const DatePicker = forwardRef<any, DatePickerProps>(DatePickerComponent);
